copybtn();

function copybtn(){

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".copy-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const coupon = btn.closest(".coupon-wrapper").querySelector(".coupon-code");
        const couponText = coupon.textContent;

        navigator.clipboard.writeText(couponText).then(() => {
          btn.textContent = "コピー済み";
          btn.disabled = true;

          setTimeout(() => {
            btn.textContent = "コピーする";
            btn.disabled = false;
          }, 2000);
        }).catch(err => {
          console.error("コピーに失敗しました: ", err);
        });
      });
    });
  });

}